/**
 * Foreign passport number validation.
 *
 * Deliberately loose: unlike Israeli national/company IDs there is no shared checksum —
 * passport formats vary by issuing country, so only a length + character-set check applies.
 */

export type PassportError = 'invalid_format';

const PASSPORT_PATTERN = /^[A-Za-z0-9]{4,20}$/;

/**
 * Validates a foreign passport number: 4-20 alphanumeric characters, no checksum.
 * Returns `null` when valid, otherwise the specific error code.
 */
export function validatePassportNumber(value: string): PassportError | null {
  if (!PASSPORT_PATTERN.test(value)) return 'invalid_format';
  return null;
}
